import {
  type GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';
import { useGetGroupTypesEnumQuery } from '~/store/services/enumerations';
import { useMemo } from 'react';
import { InputGroupV2, Tag, UniversalSelect } from '@equip.health/ui';
import { GroupTypeTagColorMapper } from '~/lib/constants/groupClasses.constants';

export const GroupTypesField = ({
  value,
  onChange,
  leftIcon,
}: GroupClassBaseFieldProps<string>) => {
  const { data: groupTypesData } = useGetGroupTypesEnumQuery();

  const groupTypeOptions = useMemo(() => {
    if (!groupTypesData) return [];
    return [...groupTypesData]
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((groupType) => ({
        label: (
          <Tag
            id={groupType.type}
            color={GroupTypeTagColorMapper[groupType.code]}
            value={groupType.type}
          />
        ),
        value: groupType.code,
      }));
  }, [groupTypesData]);

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__group-type`}
      label="Group type"
      isRequired
      shouldShowAsteriskWhenRequired
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__group-type-select`}
        isSingleSelect={true}
        onChange={(option) => {
          const selectedValue = option ? option.value : '';
          onChange(selectedValue);
        }}
        leftIcon={leftIcon}
        options={groupTypeOptions}
        placeholder="Please choose"
        value={groupTypeOptions?.find((option) => option.value === value)}
      />
    </InputGroupV2>
  );
};
